import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SAFETY_IMAGE, PRIMARY_TEL } from "@/data";
import { Overline } from "@/components/Reveal";
import { Phone, ArrowRight } from "lucide-react";

export const CtaBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 scale-125">
        <img src={SAFETY_IMAGE} alt="Washington DC" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-black/75" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 py-28 text-center md:py-40 lg:px-10">
        <Overline>Get Started</Overline>
        <h2 className="mx-auto mt-6 max-w-4xl font-serif text-5xl font-light leading-[1.05] tracking-tight text-white md:text-7xl">
          Your ride <span className="italic text-primary">awaits.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base font-light text-zinc-300">
          Transportation safety and efficiency, prioritized on every journey.
          Let's get you moving in excellence.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" })}
            data-testid="cta-book-now"
            className="group flex items-center gap-2 bg-primary px-9 py-4 text-xs font-medium uppercase tracking-[0.2em] text-primary-foreground transition-all duration-300 hover:tracking-[0.3em]"
          >
            Book Now <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <a
            href={`tel:${PRIMARY_TEL}`}
            data-testid="cta-call"
            className="flex items-center gap-3 border border-white/25 px-9 py-4 text-xs font-medium uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-primary hover:text-primary"
          >
            <Phone className="h-4 w-4" /> Call Now
          </a>
        </div>
      </div>
    </section>
  );
};
